<template>
  <div class="meditation-container">
    <h1 class="meditation-title">언집(言集)</h1>

    <div class="quote-section">
      <h2>괘언(卦言)</h2>
      <p>{{ guaQuote }}</p>
    </div>

    <div class="quote-section">
      <h2>말</h2>
      <p>{{ speechQuote }}</p>
    </div>

    <div class="quote-section">
      <h2>속담</h2>
      <p>{{ proverb }}</p>
    </div>

    <div class="button-area">
      <button @click="goBack">돌아가기</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { emotionQuotes } from '@/data/emotionQuotes'
  import { guaQuotes } from '@/data/guaQuotes'
  import { speechQuotes } from '@/data/speechQuotes'
  import { proverbs } from '@/data/proverbs'

  const router = useRouter()

  const guaQuote = ref('')
  const speechQuote = ref('')
  const emotionQuote = ref('')
  const proverb = ref('')

  const getRandomQuote = (quotes) => {
    const randomIndex = Math.floor(Math.random() * quotes.length)
    return quotes[randomIndex]
  }

  onMounted(() => {
    guaQuote.value = getRandomQuote(guaQuotes)
    speechQuote.value = getRandomQuote(speechQuotes)
    emotionQuote.value = getRandomQuote(emotionQuotes)
    proverb.value = getRandomQuote(proverbs)
  })

  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped>
  .meditation-container {
    padding: 1.2rem;
    display: flex;
    flex-direction: column;
    /* Removed justify-content: space-between; */
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    box-sizing: border-box;
  }

  .meditation-title {
    font-size: var(--font-size-14);
    text-align: center;
    margin-top: 0.5rem;
    font-weight: bold;
    margin-bottom: 1.5rem; /* Added margin-bottom */
  }

  .quote-section {
    margin-bottom: 1.5rem; /* Added margin-bottom */
    padding: 1rem;
    border: 1px solid #eee; /* Added border */
    border-radius: 8px; /* Added border-radius */
    background-color: #f9f9f9; /* Added background-color */
  }

  .quote-section h2 {
    font-size: var(--font-size-12);
    margin-top: 0; /* Adjusted margin */
    margin-bottom: 0.8rem; /* Added margin-bottom */
    color: #333; /* Adjusted color */
  }

  .quote-section p {
    font-size: var(--font-size-10);
    line-height: 1.6;
    white-space: pre-wrap; /* Preserve line breaks */
    word-break: break-word; /* Break long words */
    color: #555; /* Adjusted color */
  }

  .button-area {
    margin-top: auto; /* Push button to the bottom */
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #f44336;
    color: white;
    cursor: pointer;
  }

  button:hover {
    background-color: #da190b;
  }
</style>
